export const DEPOT_TYPE = {
  title: "Depot Type",
  values: [
    { name: "DPD", value: 1 },
    { name: "Local", value: 2 },
  ],
};

export const SHOW_LABELS = {
  title: "Show Labels",
  values: [
    { name: "On", value: true },
    { name: "Off", value: false },
  ],
};

export const SHOW_MANIFEST_LOCATION_STOPS = {
  title: "Manifest Locations",
  values: [
    { name: "On", value: true },
    { name: "Off", value: false },
  ],
};
